import { createContext, useContext, useEffect, useState } from "react";

const I18nCtx = createContext(null);

const ES = {
  nav: { inicio: "Inicio", asistencia: "Asistencia", programa: "Programa", info: "Info", mensajes: "Mensajes", menu: "Menú", galeria: "Galería" },
  inicio: {
    countdown: "Cuenta atrás",
    days: "días", hours: "horas", min: "min", seg: "seg",
    when: "18 · 07 · 2026 — 17:30h",
    where: "MIRADOR DE LES CAVES · ELS CASOTS",
  },
  asistencia: {
    title: "Confirmar asistencia",
    tabConfirm: "Confirmación",
    tabMessage: "Mensaje",
    yourAttendance: "Tu asistencia",
    willYouCome: "¿Vendrás a la boda?",
    yes: "Sí", no: "No",
    yourName: "Tu nombre",
    yourNamePh: "Nombre y apellidos",
    companionName: "Acompañante (nombre)",
    companionPh: "Nombre del acompañante (opcional)",
    children: "Niños que vienen contigo",
    dietary: "Alergias o intolerancias",
    dietaryPh: "Indícanos cualquier alergia o intolerancia",
    busTitle: "Confirmar uso del bus",
    busDesc: "El bus sale a las 17:00 desde el Hotel Domo (Vilafranca del Penedès). Solo recogemos en esta parada.",
    busOut: "¿Usarás el bus de ida (Hotel Domo → Mirador)?",
    busRet: "¿Usarás el bus de vuelta (Mirador → Hotel Domo)?",
    notes: "Notas (opcional)",
    notesPh: "Cualquier cosa que quieras decirnos…",
    submitConfirm: "Confirmar asistencia",
    messageTitle: "Mensaje para los novios",
    messageDesc: "Déjanos tu mensaje, lo leeremos con ilusión.",
    messagePh: "Escríbenos lo que quieras…",
    submitMessage: "Enviar mensaje",
    thanks: "¡Gracias por tu respuesta!",
    thanksMsg: "Nos vemos pronto.",
    thanksMessage: "¡Gracias por tu mensaje!",
    another: "Confirmar otra persona",
    venueTitle: "Cómo llegar",
    venueOpenMaps: "Abrir en Google Maps",
  },
  mensajes: {
    title: "Mensajes",
    subtitle: "Déjanos un mensaje, una felicitación o un recuerdo. Lo guardaremos para siempre.",
    another: "Enviar otro mensaje",
  },
  info: {
    title: "Información",
    subtitle: "Todo lo que necesitas saber para el gran día",
    howToGetThere: "Cómo llegar",
    openMaps: "Ver en Google Maps",
    venueSubtitles: {
      mirador: "Lugar de la ceremonia y celebración",
      "hotel-domo": "Punto de recogida del bus y alojamiento recomendado",
    },
    hotel: {
      title: "Información del hotel",
      checkIn: "Check-in",
      checkInValue: "a partir de las 14:00 h",
      checkOut: "Check-out",
      checkOutValue: "hasta las 12:00 h",
      breakfast: "Desayuno",
      breakfastValue: "de 8:00 a 11:00 h",
      parking: "Parking",
      parkingValue: "incluido",
      tip: "A la llegada indica que vienes de parte de la boda de Selena & Mario y trae tu DNI.",
    },
    gift: {
      eyebrow: "Un detalle con cariño",
      title: "Enhorabuena",
      desc: "Vuestra presencia es lo que más nos ilusiona. Si además queréis hacernos un pequeño detalle, os dejamos aquí nuestra cuenta.",
      copy: "Copiar",
      copyAria: "Copiar IBAN",
      copied: "IBAN copiado al portapapeles",
      copiedShort: "Copiado",
      note: "En el asunto pon solo vuestro nombre. Muchas gracias por acompañarnos ✿",
    },
  },
  programa: {
    title: "Programa",
    eyebrow: "El gran día",
    subtitle: "Así viviremos el sábado 18 de julio",
    nowActive: "AHORA",
    upcoming: "Próximo",
    done: "Hecho",
    liveStatus: "ESTADO EN VIVO",
    nextLabel: "Próximo:",
    happeningNow: "Ahora:",
    notStarted: "Aún no ha empezado el día",
    finished: "¡La boda ya ha terminado! Gracias por venir.",
  },
  bus: {
    title: "Viaje en bus",
    eyebrow: "Itinerario del minibús",
    outbound: "Ida — 18 julio",
    return: "Vuelta — 19 julio (madrugada)",
    liveStatus: "ESTADO EN VIVO",
    nextLabel: "Próxima parada:",
    happeningNow: "Ahora:",
    notDeparted: "El bus aún no ha salido",
    finished: "El servicio de bus ha finalizado",
  },
  menu: {
    title: "Menú",
    eyebrow: "Buen apetito",
    soon: "Próximamente publicaremos el menú",
    soonDesc: "A partir del 17 de julio de 2026 podrás consultar aquí todo el detalle de la comida.",
    preview: ["13 aperitivos", "4 paraditas", "1 plato principal", "Postre", "Pastel de boda", "Brindis"],
  },
  galeria: {
    title: "Galería",
    eyebrow: "Recuerdos",
    tabGuests: "Invitados",
    tabPros: "Profesionales",
    tabSurprises: "Sorpresas",
    uploadBtn: "Subir foto o vídeo",
    uploadTitle: "Subir fotos y vídeos",
    qrShare: "Compartir con QR",
    yourName: "Tu nombre",
    caption: "Comentario (opcional)",
    pickFile: "Elegir foto o vídeo",
    pickMany: "Elegir fotos / vídeos",
    bulkHint: "Puedes seleccionar varias fotos o vídeos a la vez (hasta 500). Máx. 100 MB por archivo. Se suben de 3 en 3.",
    singleOnlyGuest: "Solo puedes subir 1 archivo cada vez",
    change: "Cambiar",
    submit: "Compartir recuerdo",
    submitting: "Subiendo…",
    loading: "Cargando fotos…",
    singleCount: "foto",
    pluralCount: "fotos",
    singleCountShort: "foto",
    pluralCountShort: "fotos",
    proFoldersHint: "Elige una carpeta para ver las fotos:",
    backToFolders: "Carpetas",
    proUploadShort: "Subir",
    folderEmpty: "Carpeta vacía",
    folderEmptyAdmin: "Todavía no has subido fotos a esta carpeta.",
    folderEmptyGuest: "Aún no hay fotos aquí. Volveremos a mirar más tarde.",
    unfiledHint: "Tienes {n} fotos sin carpeta asignada (subidas antes de organizar por eventos).",
    loadMore: "Cargar más",
    surprisesFoldersHint: "Elige un momento para ver las fotos:",
    noSurprisesYet: "Todavía no hay carpetas de momentos disponibles.",
    emptyTitle: "Próximamente las fotos de nuestros profesionales",
    emptyDesc: "Selena y Mario las irán publicando después de la boda.",
    proUpload: "Subir fotos y vídeos",
    emptyGuests: "Sé el primero en compartir un recuerdo",
    emptyGuestsDesc: "Aún no hay fotos. Cuando suba alguna, aparecerá aquí.",
    emptyPros: "Próximamente las fotos de nuestros profesionales",
    emptyProsDesc: "Selena y Mario las irán publicando después de la boda.",
    emptySurprises: "Sorpresas en camino",
    emptySurprisesDesc: "Hemos preparado pequeñas sorpresas que iremos revelando a partir del 17 de julio de 2026.",
    locked: "PRÓXIMAMENTE",
    revealed: "REVELADO",
    couplePanel: "Modo novios",
    couplePanelActive: "Modo novios activo",
    couplePanelDesc: "Acceso privado para Selena y Mario.",
    enterCouple: "Acceder con contraseña",
    couplePassword: "Contraseña",
    couplePasswordPh: "Introduce la contraseña",
    enter: "Entrar",
    exit: "Salir",
    proUpload: "Subir fotos y vídeos profesionales",
    surpriseUpload: "Subir a esta sorpresa",
    reveal: "Revelar",
    hide: "Ocultar",
    close: "Cerrar",
    addPhoto: "Añadir foto",
    proHeader: "Próximamente",
    proSubtext: "Las fotos profesionales aparecerán aquí después del 18 de julio.",
    smallDetails: "Pequeños detalles del día",
    smallDetailsDesc: "Hemos preparado algunas sorpresas. Las iremos revelando poco a poco hasta el gran día.",
    enableNotifications: "Activar notificaciones",
    notificationsActive: "Notificaciones activas",
    seeDemo: "Ver demo",
    qrCopied: "Enlace copiado",
  },
  common: {
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    close: "Cerrar",
    loading: "Cargando…",
    backToWeb: "← Volver a la web",
    thanks: "¡Gracias!",
    nameRequired: "Necesitamos tu nombre",
    attendanceRequired: "Indica si asistirás",
    messageRequired: "Escribe tu mensaje",
    fileRequired: "Selecciona un archivo",
    onlyImages: "Solo se permiten imágenes",
    videoTooBig: "Vídeo demasiado pesado",
    videoTooLong: "El vídeo no puede durar más de 30 segundos",
    invalidVideo: "Vídeo inválido",
    unsupportedFormat: "Formato no soportado",
    fileProcessError: "Error procesando el archivo",
    deleted: "Eliminada",
    confirmDelete: "¿Eliminar?",
    revealed: "Revelada",
    hidden: "Ocultada",
    sharedTitle: "Selena & Mario · Galería",
  },
  footer: { thanks: "Gracias por ser parte de nuestra historia", admin: "Acceso novios" },
  gate: {
    welcome: "Os damos la bienvenida",
    tagline: "Nos casamos y qué mejor plan que celebrarlo juntos",
    when: "18 JULIO 2026 · MIRADOR DE LES CAVES",
    nameLabel: "TU NOMBRE",
    namePh: "Tu nombre",
    codeLabel: "CÓDIGO DE LA BODA",
    codePh: "Código de la boda",
    help: "Encontrarás el código en tu invitación. Los novios entran con su código privado.",
    submit: "ENTRAR",
    submitting: "Entrando…",
    invalidCode: "Código incorrecto",
    needName: "Escribe tu nombre",
    needCode: "Escribe el código",
    logout: "Salir",
    greeting: "Hola",
  },
};

const CA = {
  nav: { inicio: "Inici", asistencia: "Assistència", programa: "Programa", info: "Info", mensajes: "Missatges", menu: "Menú", galeria: "Galeria" },
  inicio: {
    countdown: "Compte enrere",
    days: "dies", hours: "hores", min: "min", seg: "seg",
    when: "18 · 07 · 2026 — 17:30h",
    where: "MIRADOR DE LES CAVES · ELS CASOTS",
  },
  asistencia: {
    title: "Confirmar assistència",
    tabConfirm: "Confirmació",
    tabMessage: "Missatge",
    yourAttendance: "La teva assistència",
    willYouCome: "Vindràs a la boda?",
    yes: "Sí", no: "No",
    yourName: "El teu nom",
    yourNamePh: "Nom i cognoms",
    companionName: "Acompanyant (nom)",
    companionPh: "Nom de l'acompanyant (opcional)",
    children: "Nens que vénen amb tu",
    dietary: "Al·lèrgies o intoleràncies",
    dietaryPh: "Indica'ns qualsevol al·lèrgia o intolerància",
    busTitle: "Confirmar ús del bus",
    busDesc: "El bus surt a les 17:00 des de l'Hotel Domo (Vilafranca del Penedès). Només recollim en aquesta parada.",
    busOut: "Faràs servir el bus d'anada (Hotel Domo → Mirador)?",
    busRet: "Faràs servir el bus de tornada (Mirador → Hotel Domo)?",
    notes: "Notes (opcional)",
    notesPh: "Qualsevol cosa que vulguis dir-nos…",
    submitConfirm: "Confirmar assistència",
    messageTitle: "Missatge per als nuvis",
    messageDesc: "Deixa'ns el teu missatge, el llegirem amb il·lusió.",
    messagePh: "Escriu-nos el que vulguis…",
    submitMessage: "Enviar missatge",
    thanks: "Gràcies per la teva resposta!",
    thanksMsg: "Ens veiem aviat.",
    thanksMessage: "Gràcies pel teu missatge!",
    another: "Confirmar una altra persona",
    venueTitle: "Com arribar",
    venueOpenMaps: "Obrir a Google Maps",
  },
  mensajes: {
    title: "Missatges",
    subtitle: "Deixa'ns un missatge, una felicitació o un record. El guardarem per sempre.",
    another: "Enviar un altre missatge",
  },
  info: {
    title: "Informació",
    subtitle: "Tot el que necessites saber per al gran dia",
    howToGetThere: "Com arribar",
    openMaps: "Veure a Google Maps",
    venueSubtitles: {
      mirador: "Lloc de la cerimònia i celebració",
      "hotel-domo": "Punt de recollida del bus i allotjament recomanat",
    },
    hotel: {
      title: "Informació de l'hotel",
      checkIn: "Check-in",
      checkInValue: "a partir de les 14:00 h",
      checkOut: "Check-out",
      checkOutValue: "fins a les 12:00 h",
      breakfast: "Esmorzar",
      breakfastValue: "de 8:00 a 11:00 h",
      parking: "Pàrquing",
      parkingValue: "inclòs",
      tip: "En arribar indica que véns de part de la boda de la Selena i el Mario i porta el teu DNI.",
    },
    gift: {
      eyebrow: "Un detall amb estima",
      title: "Enhorabona",
      desc: "La vostra presència és el que més ens fa il·lusió. Si a més voleu fer-nos un petit detall, us deixem aquí el nostre compte.",
      copy: "Copiar",
      copyAria: "Copiar IBAN",
      copied: "IBAN copiat al porta-retalls",
      copiedShort: "Copiat",
      note: "A l'assumpte poseu només el vostre nom. Moltes gràcies per acompanyar-nos ✿",
    },
  },
  programa: {
    title: "Programa",
    eyebrow: "El gran dia",
    subtitle: "Així viurem dissabte 18 de juliol",
    nowActive: "ARA",
    upcoming: "Pròxim",
    done: "Fet",
    liveStatus: "ESTAT EN DIRECTE",
    nextLabel: "Pròxim:",
    happeningNow: "Ara:",
    notStarted: "Encara no ha començat el dia",
    finished: "La boda ja ha acabat. Gràcies per venir!",
  },
  bus: {
    title: "Viatge en bus",
    eyebrow: "Itinerari del minibús",
    outbound: "Anada — 18 juliol",
    return: "Tornada — 19 juliol (matinada)",
    liveStatus: "ESTAT EN DIRECTE",
    nextLabel: "Pròxima parada:",
    happeningNow: "Ara:",
    notDeparted: "El bus encara no ha sortit",
    finished: "El servei de bus ha finalitzat",
  },
  menu: {
    title: "Menú",
    eyebrow: "Bon profit",
    soon: "Aviat publicarem el menú",
    soonDesc: "A partir del 17 de juliol de 2026 podràs consultar aquí tot el detall del menjar.",
    preview: ["13 aperitius", "4 paradetes", "1 plat principal", "Postres", "Pastís de noces", "Brindis"],
  },
  galeria: {
    title: "Galeria",
    eyebrow: "Records",
    tabGuests: "Convidats",
    tabPros: "Professionals",
    tabSurprises: "Sorpreses",
    uploadBtn: "Pujar foto o vídeo",
    uploadTitle: "Pujar fotos i vídeos",
    qrShare: "Compartir amb QR",
    yourName: "El teu nom",
    caption: "Comentari (opcional)",
    pickFile: "Tria foto o vídeo",
    pickMany: "Tria fotos / vídeos",
    bulkHint: "Pots triar diverses fotos o vídeos alhora (fins a 500). Màx. 100 MB per fitxer. Es pugen de 3 en 3.",
    singleOnlyGuest: "Només pots pujar 1 fitxer cada vegada",
    change: "Canviar",
    submit: "Compartir record",
    submitting: "Pujant…",
    loading: "Carregant fotos…",
    singleCount: "foto",
    pluralCount: "fotos",
    singleCountShort: "foto",
    pluralCountShort: "fotos",
    proFoldersHint: "Tria una carpeta per veure les fotos:",
    backToFolders: "Carpetes",
    proUploadShort: "Pujar",
    folderEmpty: "Carpeta buida",
    folderEmptyAdmin: "Encara no has pujat fotos a aquesta carpeta.",
    folderEmptyGuest: "Encara no hi ha fotos aquí. Tornarem a mirar més tard.",
    unfiledHint: "Tens {n} fotos sense carpeta assignada (pujades abans d'organitzar per esdeveniments).",
    loadMore: "Carrega'n més",
    surprisesFoldersHint: "Tria un moment per veure les fotos:",
    noSurprisesYet: "Encara no hi ha carpetes de moments disponibles.",
    emptyTitle: "Aviat les fotos dels nostres professionals",
    emptyDesc: "Selena i Mario les aniran publicant després de la boda.",
    proUpload: "Pujar fotos i vídeos",
    emptyGuests: "Sigues el primer a compartir un record",
    emptyGuestsDesc: "Encara no hi ha fotos. Quan en pugin alguna, apareixerà aquí.",
    emptyPros: "Aviat les fotos dels nostres professionals",
    emptyProsDesc: "Selena i Mario les aniran publicant després de la boda.",
    emptySurprises: "Sorpreses en camí",
    emptySurprisesDesc: "Hem preparat petites sorpreses que anirem revelant a partir del 17 de juliol de 2026.",
    locked: "PRÒXIMAMENT",
    lockedTitle: "Pròximament",
    revealed: "REVELAT",
    couplePanel: "Mode nuvis",
    couplePanelActive: "Mode nuvis actiu",
    couplePanelDesc: "Accés privat per a Selena i Mario.",
    enterCouple: "Accedir amb contrasenya",
    couplePassword: "Contrasenya",
    couplePasswordPh: "Introdueix la contrasenya",
    enter: "Entrar",
    exit: "Sortir",
    proUpload: "Pujar fotos i vídeos professionals",
    surpriseUpload: "Pujar a aquesta sorpresa",
    reveal: "Revelar",
    hide: "Amagar",
    close: "Tancar",
    addPhoto: "Afegir foto",
    proHeader: "Pròximament",
    proSubtext: "Les fotos professionals apareixeran aquí després del 18 de juliol.",
    smallDetails: "Petits detalls del dia",
    smallDetailsDesc: "Hem preparat algunes sorpreses. Les anirem revelant poc a poc fins al gran dia.",
    qrCopied: "Enllaç copiat",
    enableNotifications: "Activar notificacions",
    notificationsActive: "Notificacions actives",
    seeDemo: "Veure demo",
  },
  common: {
    cancel: "Cancel·lar",
    save: "Desar",
    delete: "Eliminar",
    close: "Tancar",
    loading: "Carregant…",
    backToWeb: "← Tornar a la web",
    thanks: "Gràcies!",
    nameRequired: "Necessitem el teu nom",
    attendanceRequired: "Indica si assistiràs",
    messageRequired: "Escriu el teu missatge",
    fileRequired: "Tria un arxiu",
    onlyImages: "Només es permeten imatges",
    videoTooBig: "Vídeo massa pesat",
    videoTooLong: "El vídeo no pot durar més de 30 segons",
    invalidVideo: "Vídeo invàlid",
    unsupportedFormat: "Format no compatible",
    fileProcessError: "Error processant l'arxiu",
    deleted: "Eliminada",
    confirmDelete: "Eliminar?",
    revealed: "Revelada",
    hidden: "Amagada",
    sharedTitle: "Selena & Mario · Galeria",
  },
  footer: { thanks: "Gràcies per ser part de la nostra història", admin: "Accés nuvis" },
  gate: {
    welcome: "Us donem la benvinguda",
    tagline: "Ens casem i quin millor pla que celebrar-ho junts",
    when: "18 JULIOL 2026 · MIRADOR DE LES CAVES",
    nameLabel: "EL TEU NOM",
    namePh: "El teu nom",
    codeLabel: "CODI DE LA BODA",
    codePh: "Codi de la boda",
    help: "Trobaràs el codi a la teva invitació. Els nuvis entren amb el seu codi privat.",
    submit: "ENTRAR",
    submitting: "Entrant…",
    invalidCode: "Codi incorrecte",
    needName: "Escriu el teu nom",
    needCode: "Escriu el codi",
    logout: "Sortir",
    greeting: "Hola",
  },
};

const DICT = { es: ES, ca: CA };

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("wedding_lang") || "es");
  useEffect(() => { localStorage.setItem("wedding_lang", lang); }, [lang]);
  const t = DICT[lang];
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
};

export const useI18n = () => useContext(I18nCtx);

